import { Rate } from '@sravni/react-design-system/lib/Rate';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';

import type { CellContext } from '@tanstack/table-core';

import type { RatingItem } from '../../../types/rating';

export const makeRatingColumn = <T extends RatingItem>(info: CellContext<T, any>) => {
  const { rating } = info.row.original;

  return (
    <Space direction="horizontal" size={4} align="center" justify="end">
      <Rate count={1} value={1} disabled />
      <Text size={14} strong>
        {rating.toFixed(2)}
      </Text>
    </Space>
  );
};
